import { render, staticRenderFns } from "./ManageUniversityRatings.vue?vue&type=template&id=74da9245&scoped=true&"
import script from "./ManageUniversityRatings.vue?vue&type=script&lang=js&"
export * from "./ManageUniversityRatings.vue?vue&type=script&lang=js&"
import style0 from "./ManageUniversityRatings.vue?vue&type=style&index=0&id=74da9245&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da9245",
  null
  
)

export default component.exports